import { Button, twMerge } from '@sortlist-frontend/design-system';
import { ArrowRight } from '@sortlist-frontend/design-system/icons';
import { useEffect, useState } from 'react';

import type { GuideCta } from '../types';

interface GuideStickyCtaProps {
  cta: GuideCta;
}

const SHOW_AFTER_PX = 700;

export const GuideStickyCta = (props: GuideStickyCtaProps) => {
  const { cta } = props;
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsShown(window.scrollY > SHOW_AFTER_PX);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={twMerge(
        'fixed inset-x-4 bottom-4 z-40 transition-all duration-300 md:hidden',
        isShown ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0',
      )}>
      <Button
        as="a"
        href={cta.href}
        color="primary"
        variant="solid"
        size="lg"
        hasShadow
        fullWidth
        endContent={<ArrowRight />}>
        {cta.label}
      </Button>
    </div>
  );
};
